/**
 * タグ絞り込みフォーム：チェックボックス／ラジオ変更時に自動送信
 */
export function initTagFilterForm() {
  const forms = document.querySelectorAll( '.mj-tag-filter-form' );
  forms.forEach( ( form ) => {
    const inputs = form.querySelectorAll( 'input[type="checkbox"], input[name="tag_mode"]' );
    inputs.forEach( ( input ) => {
      input.addEventListener( 'change', () => {
        form.submit();
      } );
    } );
  } );
}
